import type {ChromelessPlayer} from 'theoplayer';

import {safeAccess} from '../../utils/objectUtils';

export class THEOplayerProxy {
  constructor(private readonly rawPlayer: ChromelessPlayer) {}

  addEventListener: ChromelessPlayer['addEventListener'] = (type, listener) => {
    safeAccess(() => this.rawPlayer.addEventListener(type, listener));
  };

  get currentTime(): ChromelessPlayer['currentTime'] | undefined {
    return safeAccess(() => this.rawPlayer.currentTime);
  }

  get duration(): ChromelessPlayer['duration'] | undefined {
    return safeAccess(() => this.rawPlayer.duration);
  }

  get autoplay(): ChromelessPlayer['autoplay'] | undefined {
    return safeAccess(() => this.rawPlayer.autoplay);
  }

  get muted(): ChromelessPlayer['muted'] | undefined {
    return safeAccess(() => this.rawPlayer.muted);
  }

  get version(): ChromelessPlayer['version'] | undefined {
    return safeAccess(() => this.rawPlayer.version);
  }

  get videoHeight(): ChromelessPlayer['videoHeight'] | undefined {
    return safeAccess(() => this.rawPlayer.videoHeight);
  }

  get videoWidth(): ChromelessPlayer['videoWidth'] | undefined {
    return safeAccess(() => this.rawPlayer.videoWidth);
  }

  get errorObject(): ChromelessPlayer['errorObject'] | undefined {
    return safeAccess(() => this.rawPlayer.errorObject);
  }

  get element(): ChromelessPlayer['element'] | undefined {
    return safeAccess(() => this.rawPlayer.element);
  }

  get source(): ChromelessPlayer['source'] | undefined {
    return safeAccess(() => this.rawPlayer.source);
  }

  get cast(): ChromelessPlayer['cast'] | undefined {
    return safeAccess(() => this.rawPlayer.cast);
  }

  get presentation(): ChromelessPlayer['presentation'] | undefined {
    return safeAccess(() => this.rawPlayer.presentation);
  }

  get videoTracks(): ChromelessPlayer['videoTracks'] | undefined {
    return safeAccess(() => this.rawPlayer.videoTracks);
  }

  get audioTracks(): ChromelessPlayer['audioTracks'] | undefined {
    return safeAccess(() => this.rawPlayer.audioTracks);
  }

  get textTracks(): ChromelessPlayer['textTracks'] | undefined {
    return safeAccess(() => this.rawPlayer.textTracks);
  }

  get ads(): ChromelessPlayer['ads'] | undefined {
    return safeAccess(() => this.rawPlayer.ads);
  }

  get network(): ChromelessPlayer['network'] | undefined {
    return safeAccess(() => this.rawPlayer.network);
  }
}
